import PropTypes from "prop-types"
import React from "react"

import CruiseStopItemMobile from "./CruiseStopItemMobile"

const CruisePlanMobile = ({ stops, cruisePlanId, handleMoveStop }) => {
  const renderStop = () => {
    let previousStop = null
    const stopItems = []
    stops.forEach((stop, index) => {
      stopItems.push(
        <div key={stop.id} className="mb-4">
          <CruiseStopItemMobile
            stop={stop}
            previousStop={previousStop}
            cruisePlanId={cruisePlanId}
            handleMoveStop={handleMoveStop}
            index={index}
          />
        </div>
      )
      previousStop = stop
    })
    return stopItems
  }

  return <div className="lg:hidden">{renderStop()}</div>
}

CruisePlanMobile.propTypes = {
  stops: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
    })
  ).isRequired,
  cruisePlanId: PropTypes.string.isRequired,
  handleMoveStop: PropTypes.func.isRequired,
}

export default CruisePlanMobile
